//Vue Router
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

//Components Import
import Login from '../components/account/login'
import ForgotPassword from '../components/account/forgotPassword'
import ResetPassword from '../components/account/resetPassword'
import Account from '../components/account/index'
import Dashboard from '../components/dashboard/index'
import MonitoriaTransaccion from '../components/monitoria/transaccion'
import PreMonitoriaTransaccion from '../components/premonitoria/transaccion'
import Graduados from '../components/graduados/graduados'
import PeriodoGraduacion from '../components/graduados/periodoGraduacion'
import Certificaciones from '../components/graduados/certificaciones'
import Diplomas from '../components/diplomas/index'
import Documentos from '../components/documentos/index'

export default new Router({
    routes: [
        Login,
        ForgotPassword,
        ResetPassword,
        Account,
        Dashboard,
        MonitoriaTransaccion,
        PreMonitoriaTransaccion,
        Graduados,
        PeriodoGraduacion,
        Certificaciones,
        Diplomas,
        Documentos
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js